import React from "react";
import QARTask from "./QARTask";
import { QARTaskApproverDialog } from "./QARTaskApproverDialog";
import Api from '../../services/Api'



class SingleQARTask extends React.Component {

    state = {
        closeDialog: false,
        isNotificationOnly : false,
        showThankYouPage: false,
        isSaving: false
    }

    closeDialog = () => {
        this.setState({closeDialog: true});

        if (this.state.showThankYouPage)
            this.props.refresh();
    }
    
    approveQarTask = () => {
        this.setState({isSaving: true});

        const url = '/ApproveQAR';
        const post = {
            id: this.props.element.id
        };

        Api.post(url, post)
            .then(res => res.data)
            .then(post => {
                this.setState({isSaving: false});
                if (post === 200) {
                    this.setState({showThankYouPage: true});
                } else {
                    console.log("Update failed")
                }
            }).catch((error) => {
                console.log(error)
            })
    }

    render() {
        const showDialog = !this.state.closeDialog && (this.state.showThankYouPage || this.props.showDialog);
        const showTask = !showDialog && !this.state.showThankYouPage && !this.props.showDialog;
        const qarTask = <QARTask
                            task = {this.props.element}
                            onApprove = {this.approveQarTask}
                            showThankYouPage = {this.state.showThankYouPage}
                            closeDialog = {this.closeDialog}
                            inDialog = {this.props.showDialog}
                            isSaving = {this.state.isSaving}
                        />
        return (
            <div>
                {   
                    showDialog && <QARTaskApproverDialog 
                                        qarTask = {qarTask}
                                        closeDialog = {this.closeDialog}
                                    />
                }
                {
                    showTask && qarTask
                }
            </div>
        );
    }
}
export default SingleQARTask


// WEBPACK FOOTER //
// ./src/components/ManageCenter/SingleQARTask.js